import tailwindConfig from './../../../tailwind.config'
import resolveConfig from "tailwindcss/resolveConfig";
import ListingData from "./ListingData";
const config = resolveConfig(tailwindConfig)

export default (nid, data) => {
  return {
    nid: nid,
    name: ListingData.getItemById(nid)?.name,
    label: false,
    spanGaps: true,
    backgroundColor: config.theme.colors.accent.light,
    borderColor: config.theme.colors.accent.light,
    cubicInterpolationMode: 'monotone',
    data: data,
    fill: false,
  }
}
